import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Avatar from 'react-avatar';
import { Table, Row, Col, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBan, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { fetchUsers, 
  filterUsers, 
  enableUser, 
  disableUser, 
  clearUsers, 
  SET_USERS_PAGINATION, 
  RESET_USERS_PAGINATION, 
  PORTAL_ADMIN, 
  HR_ADMIN } from '../../../store/actions/users/usersActions';
import { togglePrompt, resetPagination } from '../../../store/actions/commonActions';
import { ConfirmDialog } from '../../../common/Utilities';
import { Cache } from 'aws-amplify';
import ListPagination from '../../../common/ListPagination';

class Users extends Component {

  constructor(props) {
    super(props);
    this.user = {}
    this.defaultRole = {}
    this.createUserButton = "Create User";
    this.showDisabledUsers = false;
    this.action = '';
    this.enableUser = 'ENABLE_USER';
    this.disableUser = 'DISABLE_USER';
  }

  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === HR_ADMIN) {
      const pathname = this.props.location.pathname;
    
      if (pathname === '/settings/users/disabled') {
        this.props.fetchUsers({is_disabled: 1});
      }
      else {
        this.props.fetchUsers({is_disabled: 0});
      }
    }
    else {
      this.props.history.push('/dashboard');
    }
    this.props.filterUsers('');
    this.props.resetPagination(RESET_USERS_PAGINATION);
  }

  promptModal = () => {
    let modalTitle = '';
    let modalBody = '';
    let verb = '';

    if (this.action === this.enableUser) {
      modalTitle = "Enable User";
      verb = 'enable';
    }
    else {
      modalTitle = "Disable User";
      verb = 'disable';
    }

    modalBody = "Are you sure you want to " + verb +  " this user?"
    
    const onHideFunction = () => {
      this.props.togglePrompt(false);
    }

    const onClickCancel = () => {
      this.props.togglePrompt(false);
    }

    const onClickConfirm = () => {
      if (this.action === this.enableUser) {
        this.props.enableUser(this.user.id);
      }
      else {
        this.props.disableUser(this.user.id);
      }

      this.props.togglePrompt(false);
    }

    return (
        <ConfirmDialog 
            show={this.props.common.togglePrompt} 
            modalTitle={modalTitle} 
            modalBody={modalBody} 
            onHideFunction={onHideFunction}
            onClickCancel={onClickCancel}
            onClickConfirm={onClickConfirm}
        />
    ) 
  }

  getFilteredUsers = (users) => {
    if (!users) {
      return null;
    }

    return users.filter(user => {
        const firstName = user.first_name || '';
        const lastName = user.last_name || '';
        const email = user.email || '';
        const band = user.band ? user.band.band_name || '' : '';
        const platformName = user.group ? user.group.platform_name || '' : '';
        const userRoles = user.roles && user.roles.length ? user.roles.map(role => role.role_name).join(' ') : '';

        const userData = [
          firstName,
          lastName,
          email,
          band,
          platformName,
          userRoles
        ].join(" ").toLowerCase();
        
        const userFilter = this.props.users.userFilter; 

        if (!userFilter || userData.includes(userFilter.toLowerCase())) {
          return user;
        }
        return null;
        
      })
  }

  getUsers = () => {
    let users = this.getFilteredUsers(this.props.users.users);
   
    if (users) {
      //if the user tries to search and no matches the filter
      if (this.props.users.userFilter && !users.length) {
        users = null;
      }
      else {
        let min = this.props.users.min;
        let max = this.props.users.max;
      
        //don't paginate if there's filter
        if (!this.props.users.userFilter) {
          users = users.slice(min - 1, max);
        }
      }
    }

    let userList = [];

    if (users) {
      userList = users.length ? (
        users
          .map((user, key) => {
            const fullName = user.last_name + ", " + user.first_name;
            let disableToggle = user.is_disabled ? <Button size="sm" onClick={() => {
              this.user = user;
              this.action = this.enableUser;
              this.props.togglePrompt(true);
            }}>
              <FontAwesomeIcon icon={faUserCheck} /> Enable 
            </Button> : <Button size="sm"  onClick={() => {
              this.user = user;
              this.action = this.disableUser;
              this.props.togglePrompt(true);
            }}>
              <FontAwesomeIcon icon={faBan} /> Disable
            </Button> 


            if (user.roles.filter(role => role.id === PORTAL_ADMIN).length) {
              disableToggle = ''; //no delete for admins
            }
            return (
              <tr key={key}>
                <td>
                  <Avatar name={fullName} size="40" round={true} />
                </td>
                <td>
                  {fullName}
                  <div className="text-muted small">
                    {user.email}
                  </div>
                </td>
                <td>
                  <div className="float-right tbl-funcs">
                    
                    {disableToggle}
                    <Button size="sm" className='btn-primary' onClick={() => {
                      this.props.history.push('/settings/users/update?id='+user.id);
                    }}>
                      <FontAwesomeIcon icon={faPen} /> Edit
                    </Button>
                  </div>
                </td>
              </tr>
            )
          })
      ) : (
        <tr>
          <td colSpan={3}>
            Loading...
          </td>
        </tr>
      )
    }
    else {
      userList = (
        <tr>
          <td colSpan={3}><p className="text-danger">No users found.</p></td>
        </tr>
      ) 
    }

    return userList;
  }

  filterUsers = () => {
    return (
      <Form.Control size="xl" type="search" placeholder="Filter Users" onChange={(e) => {
        const filter = e.target.value;
        this.props.filterUsers(filter);
      }} />
    )
  }


  renderUsers = () => {
    return (
      <Table hover>
        <thead className="align-center">
          <tr>
            <th width="5%"></th>
            <th width="65%">Name</th>
            <th width="30%">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={3}>
              { this.filterUsers() }
            </td>
          </tr>
          { this.getUsers() }
        </tbody>
      </Table>
    )
  }
  
  render() {
    const pathname = this.props.location.pathname;

    if (pathname === '/settings/users/disabled') {
      this.showDisabledUsers = true;
    }
    else {
      this.showDisabledUsers = false;
    }

    const listPagination = 
      !this.props.users.userFilter ?
        <ListPagination 
          dispatchType={SET_USERS_PAGINATION}
          data={this.props.users.users} 
          min={this.props.users.min}
          max={this.props.users.max}
          currentPage={this.props.users.currentPage} 
          totalPages={this.props.users.totalPages} 
          fetchCallback="" 
          numItems={this.props.users.numItems} />
        
        : '';

    return (
      <React.Fragment>
        { this.promptModal() }
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            { this.showDisabledUsers ? <h5>Disabled Users</h5> : <h5>Users</h5> }
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <div className="float-right">
              <Button id="createUser" size="sm" onClick={() => {

                let createUser = document.getElementById("createUser");
                createUser.disabled = true;
                createUser.textContent = "creating...";

                this.props.history.push('/settings/users/add');

                createUser.disabled = false;
                createUser.textContent = "Created";
                setTimeout(() => {  
                  createUser.textContent = this.createUserButton;
                }, 1000);
              }}>{this.createUserButton}</Button>
            </div>
          </Col>
        </Row>
        <hr />
        <Row className="mt-3">
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            {this.showDisabledUsers ? (
              <Button variant="outline-secondary" size="sm" onClick={() => {
                this.props.history.push('/settings/users');
                this.showDisabledUsers = false;
                this.props.resetPagination(RESET_USERS_PAGINATION);
                this.props.clearUsers();
                this.props.fetchUsers({is_disabled: 0});
              }}>
                Show Active Users
              </Button> 
            ) : (
              <Button variant="outline-secondary" size="sm" onClick={() => {
                this.props.history.push('/settings/users/disabled');
                this.showDisabledUsers = true;
                this.props.resetPagination(RESET_USERS_PAGINATION);
                this.props.clearUsers();
                this.props.fetchUsers({is_disabled: 1});
              }}>
                Show Disabled Users
              </Button> 
            )}
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="float-right">
              {listPagination}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            { this.renderUsers() }
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="float-right">
              {listPagination}
            </div>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: (...args) => dispatch(fetchUsers(...args)),
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
    filterUsers: (...args) => dispatch(filterUsers(...args)),
    enableUser: (...args) => dispatch(enableUser(...args)),
    disableUser: (...args) => dispatch(disableUser(...args)),
    clearUsers: () => dispatch(clearUsers()),
    resetPagination: (...args) => dispatch(resetPagination(...args)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users))
